export default __webpack_public_path__ + "media/logos/white_2x-2c252df3.png";